import {
  prepareSelectOptions,
  scrollToError,
  getBrowserLocale,
  debounce,
  prepareResponse,
  getValueFromObjectItem,
  getValueFromArr,
  sumOfArrayNumbers,
  initEmailMask,
  initPhoneMask,
  initInnMask,
  initKppMask,
  initSnilsMask,
  isValidDate,
  formatDate,
  formatMoney,
  getDeclinationFromNumber,
  findOne,
  findAll,
  firstToUppercase,
  maskDate,
  isObject,
  getUniqueKey,
  required,
  cutString,
  arrayToCutString,
  getDeepCopyObject,
  getNowDate,
  isEqual,
  isArraysEqual,
  areArraysEqual,
  unflatenObject,
  flattenObject,
  mountSubFilter,
  tableColumnsUtils,
} from 'r3ui-lib';
import { navigateTo } from '#imports';
import type { SidebarLink } from '~/interfaces/sidebar.interface';

export const prepareColumnsToSave = (...args: unknown[]) => {
  const fn = tableColumnsUtils?.prepareColumnsToSave;
  return typeof fn === 'function'
    ? (fn as (...params: unknown[]) => unknown)(...args)
    : args[0];
};

export function getChildrensIsActive(links: SidebarLink[]) {
  if (!links?.length) return false;
  const first = links[0];
  if (!first?.childrens?.length) return false;
  return (
    first.childrens.find(item => Boolean(item.isActive))?.isActive || false
  );
}

export function redirectTo(url: string) {
  if (url.length < 1) {
    return false;
  }
  navigateTo(url);
}

export {
  prepareSelectOptions,
  scrollToError,
  getBrowserLocale,
  debounce,
  prepareResponse,
  getValueFromObjectItem,
  getValueFromArr,
  sumOfArrayNumbers,
  initEmailMask,
  initPhoneMask,
  initInnMask,
  initKppMask,
  initSnilsMask,
  isValidDate,
  formatDate,
  formatMoney,
  getDeclinationFromNumber,
  findOne,
  findAll,
  firstToUppercase,
  maskDate,
  isObject,
  getUniqueKey,
  required,
  cutString,
  arrayToCutString,
  getDeepCopyObject,
  getNowDate,
  isEqual,
  isArraysEqual,
  areArraysEqual,
  unflatenObject,
  flattenObject,
  mountSubFilter,
};
